import { render, staticRenderFns } from "./IconListProviders.vue?vue&type=template&id=c13a14f4&"
import script from "./IconListProviders.vue?vue&type=script&lang=js&"
export * from "./IconListProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports